
  <!--<span class="serial">{{index + 1}}.</span>-->
  <div class="flex form-row">
  <mat-form-field class="horizontal">
    <input matInput placeholder="Contact Name *" name="contactName" (keyup)="setValidityOfContact()" [formControl]="contactNameFormControl" [(ngModel)]="contact.name">
    <mat-error *ngIf="contactNameFormControl.hasError('required')">
      Contact Name is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field class="horizontal">
    <input matInput placeholder="Contact Email *" name="contactEmail" (keyup)="setValidityOfContact()" [formControl]="contactEmailFormControl" [(ngModel)]="contact.email">
    <mat-error *ngIf="contactEmailFormControl.hasError('required')">
      Contact Email is <strong>required</strong>
    </mat-error>
    <mat-error *ngIf="contactEmailFormControl.hasError('pattern')">
      Please enter a valid email address
    </mat-error>
  </mat-form-field>

  <mat-form-field class="horizontal">
    <input matInput placeholder="Job Function *" name="contactJob" (keyup)="setValidityOfContact()" [formControl]="contactJobFormControl" [(ngModel)]="contact.job">
    <mat-error *ngIf="contactJobFormControl.hasError('required')">
      Job Function is <strong>required</strong>
    </mat-error>
  </mat-form-field>


  <mat-form-field class="horizontal">
    <input type="text" placeholder="Work Location *" aria-label="Number" matInput [formControl]="contactLocationFormControl" (keyup)="setValidityOfContact()" [matAutocomplete]="auto"
           [(ngModel)]="contact.location">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setValidityOfContact()">
      <mat-option *ngFor="let country of invoiceCountries | async" [value]="country">
        {{ country }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="contactLocationFormControl.hasError('required')">
      Work Location is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  </div>

  <div class="flex form-row">

  <mat-form-field class="horizontal">
    <input matInput placeholder="J.P. Morgan Sales Representative (if applicable)" name="contactSalesRep" [(ngModel)]="contact.salesRepresentative">
  </mat-form-field>
  </div>
  <!--<button class="add-contact" *ngIf="last" type="button" mat-raised-button color="primary" (click)="addAnotherContact()">Add Another Contact</button>-->

